import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import SupplierCreateUpdate, {
  SupplierCreateUpdateHandle,
  SupplierCreateUpdateProps,
} from "./SupplierCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: SupplierCreateUpdateProps;
}

export default function SupplierCreateUpdateModal({ createUpdateProps, ...modalProps }: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.supplierId });
  const formWrapperRef = useRef<SupplierCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} supplier
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <SupplierCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
